import logoutIcon from '@/images/logout.svg';
import { useNavigate } from 'react-router-dom';
import { VersionManagement } from './VersionManagement';
import { UserContext, useUserContext } from '@/contexts/userContext';
import { useEffect, useState } from 'react';
import { Account, VersionAccount } from '@/types';
import { useTranslation } from 'react-i18next';
import { useApiService } from '@/hooks/useApiService';

function UserProfile() {
    const { t } = useTranslation();
    const { getVersionsAccountStatuses, getAccountInfos } = useApiService();
    const navigate = useNavigate();
    const [accountInfos, setAccountInfos] = useState<Account>();
    const [versions, setVersions] = useState<VersionAccount[]>([]);

    const { logout: userLogout } = useUserContext() as UserContext;

    useEffect(() => {
        const fetchData = async () => {
            const accountInfos = await getAccountInfos();
            const accountVersions = (await getVersionsAccountStatuses()) as VersionAccount[];

            setAccountInfos(accountInfos);
            setVersions(accountVersions);
        };
        fetchData().catch(console.error);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!accountInfos) {
        return;
    }
    if (Object.keys(accountInfos).length > 0) {
        return (
            <>
                <div className="z-10 relative min-h-[100vh] bg-white m-auto flex flex-col items-center overflow-x-hidden">
                    <div className="relative z-20 mt-20 mb-12 flex w-[90%] flex-col items-center rounded-2xl bg-white p-14 shadow-xl md:w-[700px] lg:w-[960px] xl:items-center">
                        <div className="flex flex-row w-full items-center justify-between">
                            <h1 className="text-text-dark font-semibold text-3xl">{t('school_profile')}</h1>
                            <button
                                className="flex flex-row gap-2 items-center rounded-full justify-center w-fit px-4 h-12 bg-white/70 backdrop-blur-lg border border-[#EAECF0] shadow-sm hover:shadow-md hover:cursor-pointer active:shadow-none active:bg-gray-50"
                                onClick={() => {
                                    userLogout();
                                    navigate('/');
                                }}
                            >
                                <img src={logoutIcon} alt="Disconnect" />
                                <span className="font-semibold text-md text-text-dark">{t('school_disconnect')}</span>
                            </button>
                        </div>
                        <div className="mt-8 w-full border-t border-[#E0E3E9]"></div>
                        <div className="flex w-full flex-col mt-6">
                            <h2 className="font-semibold text-xl text-text-dark">{t('school_infos')}</h2>
                            <div className="flex flex-row mt-6 gap-16 items-center">
                                {accountInfos?.imageUrl && (
                                    <div className="align-center">
                                        <img className="object-contain w-44 h-32" src={accountInfos.imageUrl}></img>
                                    </div>
                                )}

                                <div className="flex flex-col gap-1">
                                    <p className="text-md text-text-grey font-semibold">
                                        {accountInfos.firstname + ' ' + accountInfos.lastname}
                                    </p>
                                    <p className="text-md text-text-grey font-semibold">{accountInfos.company}</p>
                                    <p className="text-md text-text-grey font-semibold">{accountInfos.email}</p>
                                </div>
                            </div>
                        </div>

                        <VersionManagement account={accountInfos} accountVersions={versions} />
                    </div>
                </div>
            </>
        );
    }
}

export default UserProfile;
